module.exports = __webpack_public_path__ + "static/media/step_medico_sistema.354fb16a.jpg";